import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import staticPath from 'util/misc/static-assets-path';

class OnboardingIntroOverlay extends PureComponent {
    static propTypes = {
        openModal: PropTypes.func.isRequired,
        pageName: PropTypes.string.isRequired,
    };

    render() {
        return (
            <div className="onboarding-intro">
                <div onClick={() => this.props.openModal({ layout: 'zip-form' })} className="onboarding-intro--inner grid--container">
                    <img className="onboarding-intro--logo" src={staticPath('img/logos/amigos-large.svg')}/>
                </div>
            </div>
        );
    };
};

export default connect(
    reduxUtils.mapStateToProps({
        pageName: 'router.name',
    }),
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
    }),
)(OnboardingIntroOverlay);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/onboarding/intro/index.js